import fe_config from "constants/Configs";
import get from "lodash/get";
import trim from "lodash/trim";
import { numberRegEx, urlRegEx } from "../constants/regex";

export const getValueFromUrl = (_url = "", _key = "") =>
  _url
    ? get(
        _url
          .split("&")
          .filter((x) => x)
          .map((x) => x.split("="))
          .find((param) => [_key].includes(param[0])),
        "[1]",
        ""
      )
    : "";

export const getValueFromLocalFilter = (fetch_from_key = "", _key = "") => {
  const obj = JSON.parse(localStorage.getItem(fetch_from_key) || "{}");
  return obj[_key];
};

export const deleteValuesFromURL = (_url = "", _keys = "") => {
  const result = _url
    .split("&")
    .filter((x) => x)
    .map((x) => x.split("="))
    .filter((param) => !_keys.includes(param[0]))
    .map((x) => x.join("="))
    .join("&");
  return _url ? result : "";
};

export const deleteEmptyValuesFromURL = (_url = "") => {
  const result = _url
    .split("&")
    .filter((x) => x)
    .map((x) => x.split("="))
    .filter(
      (param) =>
        param[1] &&
        param[1] !== undefined &&
        (!Array.isArray(param[1]) || param[1].length > 0)
    )
    .map((x) => x.join("="))
    .join("&");
  return _url ? result : "";
};

export const encodeValues = (value) =>
  value && "X".repeat(10) + value.substr(value.length - 4);

export function deURLify(string) {
  return string
    .trim()
    .replace("%20", "")
    .replace("%22", "")
    .replace("%27", "")
    .replace(/'/g, "", "");
}

export function trimText(str) {
  return trim(str);
}

export function removeFirstNumberWord(str) {
  return String(str).split(" ")[0].match(numberRegEx)
    ? str.split(" ").slice(1).join(" ")
    : str;
}

export function removeNumbersFromWord(str) {
  return String(str)
    .split(" ")
    .filter((word) => !word.match(numberRegEx))
    .join(" ");
}

export function urlify_string_only(text) {
  const str = text.split("<").join(" < ");
  const str1 = str.split(">").join(" > ");
  let res = "";
  str1.replace(urlRegEx, function (url) {
    res = url;
    return url;
  });
  return res.replace(fe_config.REACT_APP_URL, window.location.origin);
}

export function urlify(text) {
  const str = text.split("<").join(" < ");
  const str1 = str.split(">").join(" > ");
  const x = str1.replace(urlRegEx, function (url) {
    return `<a class="disabled" href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
  });
  return `<span>${x}</span>`;
}

/**
 * Converts plain text with line breaks to HTML format
 * Preserves existing HTML formatting if already present
 * @param {string} text - Plain text or HTML string
 * @returns {string} - HTML formatted string with proper paragraph and line break tags
 */
export function convertTextToHtml(text) {
  if (!text) {
    return text;
  }

  // Check if the content is already HTML
  const hasHtmlTags = /<[^>]+>/.test(text);

  if (!hasHtmlTags) {
    const normalized = String(text).replace(/\r\n/g, "\n");
    const escapeHtml = (s) =>
      s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

    const paragraphs = normalized
      .split(/\n\s*\n/)
      .filter((p) => p.trim())
      .map((p) => `<p>${escapeHtml(p).replace(/\n/g, "<br>")}</p>`)
      .join("");
    return paragraphs;
  }

  // Already HTML: preserve as-is
  return text;
}
